import { render, staticRenderFns } from "./AddressSelector.vue?vue&type=template&id=0beb6a22&"
import script from "./AddressSelector.vue?vue&type=script&lang=js&"
export * from "./AddressSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports